import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const greetings = [
    "Hello",      // English (Last)
    "مرحبا",     // Arabic
    "こんにちは",  // Japanese
    "Hola",      // Spanish
    "Bonjour",   // French
    "Hallo",     // German
    "Ciao",      // Italian
    "Olá",       // Portuguese
    "வணக்கம்",   // Tamil
    "Привет",    // Russian
    "你好",       // Chinese
    "안녕하세요",  // Korean
    "Hello"      // English (Last)
];

interface PreloaderProps {
    onComplete: () => void;
}

const Preloader: React.FC<PreloaderProps> = ({ onComplete }) => {
    const [index, setIndex] = useState(0);

    useEffect(() => {
        if (index === greetings.length - 1) {
            const done = setTimeout(onComplete, 1000);
            return () => clearTimeout(done);
        }

        const isFirstGreeting = index === 0;
        const duration = isFirstGreeting ? 400 : 180;

        const timer = setTimeout(() => {
            setIndex((prev) => prev + 1);
        }, duration);

        return () => clearTimeout(timer);
    }, [index, onComplete]);

    return (
        <AnimatePresence>
            <motion.div
                className="fixed inset-0 z-[9999] flex items-center justify-center bg-black cursor-none overflow-hidden"
                initial={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.8, ease: "easeInOut" }}
            >
                <div className="relative w-full h-full flex items-center justify-center">
                    <AnimatePresence mode="wait">
                        <motion.h1
                            key={greetings[index]}
                            className="absolute text-white text-6xl md:text-8xl font-light tracking-tighter"
                            initial={{ opacity: 0, scale: 0.75 }}
                            animate={{ opacity: 1, scale: 1 }}
                            exit={{ opacity: 0, scale: 0.75 }}
                            transition={{ duration: 0.25, ease: "easeOut" }}
                        >
                            {greetings[index]}
                        </motion.h1>
                    </AnimatePresence>
                </div>
            </motion.div>
        </AnimatePresence>
    );
};

export default Preloader;
